var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0H1.5C0.65625 0 0 0.6875 0 1.5V12.5C0 13.3438 0.65625 14 1.5 14H5.78125V9.25H3.8125V7H5.78125V5.3125C5.78125 3.375 6.9375 2.28125 8.6875 2.28125C9.5625 2.28125 10.4375 2.4375 10.4375 2.4375V4.34375H9.46875C8.5 4.34375 8.1875 4.9375 8.1875 5.5625V7H10.3438L10 9.25H8.1875V14H12.5C13.3125 14 14 13.3438 14 12.5V1.5C14 0.6875 13.3125 0 12.5 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.ab8317d4ffc74462810523ae14a93bb7.svg";
export { ForwardRef as ReactComponent };